:host {
  display: inline-block;
  position: relative;

  --z-index: var(--navbar-tooltip-z-index, 100);
}

.EcoSuiteNavbarTooltip {
  position: absolute;
  inset-inline-start: 0;
  top: 0;
  z-index: var(--z-index);
  pointer-events: none;
  white-space: nowrap;
  max-width: 240px;
  overflow: hidden;
  text-overflow: ellipsis;
  background-color: var(--pdt-color-bg-inverse);
  color: var(--pdt-color-text-on-bold);
  font-size: var(--pdt-font-size-xs);
  line-height: var(--pdt-line-height-2xs);
  padding: var(--pdt-space-25) var(--pdt-space-75);
  border-radius: var(--pdt-radius-50);
  transition: transform .2s ease;
  opacity: 0;
  width: 0;
  visibility: hidden;
  transform: scale(0.95);

  &--visible {
    opacity: 1;
    visibility: visible;
    width: auto;
    transform: scale(1);
  }

  &--hasIcon {
    display: flex;
    align-items: center;

    pwc-icon-shadow {
      --size: 14px;
    }
  }

  &--hasExternalLinkIcon {
    gap: var(--pdt-space-75);
  }

  &--hasChevronIcon {
    gap: var(--pdt-space-50);
    padding-right: var(--pdt-space-25);
  }
}
